import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import moment from "moment";
import {
  Box,
  Chip,
  FormControlLabel,
  IconButton,
  Switch,
  Tooltip,
  Typography,
} from '@mui/material';
import Delete from '@mui/icons-material/Delete';
import DoneAll from '@mui/icons-material/DoneAll';
import { GridToolbarContainer } from '@mui/x-data-grid';
import "./style.css";
import { TABLE } from "../../enums/tablesEnum";
import DialogDeleteCustom from "../DialogDeleteCustom/DialogDeleteCustom";
import FormTacheModal from "../FormTacheModal/FormTacheModal";
import { addTacheContact, editTacheContact } from "../../services/TacheContactService";
import { addTacheCandidat, editTacheCandidat } from "../../services/TacheCandidatService";
import ViewTacheModal from "../ViewTacheModal/ViewTacheModal";
import { withSnackbar } from "../../utils/SnackbarHOC";
import LabelReadMoreReadLess from "../LabelReadMoreReadLess/LabelReadMoreReadLess";
import { DataGrid } from '../SortableDataGrid/SortableDataGrid';

function TabPanelTaches({
  snackbarShowMessage,
  deleteTache,
  getAllTachesFaites,
  getAll,
  tacheFrom,
  disableTableBodyMax = false,
  ...rest
}) {
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [taches, setTaches] = useState([]);
  const [tacheInfo, setTacheInfo] = useState({ affecteA: "", tacheId: "" });
  const [openDialogDelete, setOpenDialogDelete] = useState(false);
  const [loadingToDelete, setLoadingToDelete] = useState(false);
  const [reloadingData, setReloadingData] = useState(false);
  const [tachesTermines, setTachesTermines] = useState(false);

  const parametters = useParams();
  const idCandidat = rest?.idCandidat ?? parametters.idCandidat;
  const idContact = (rest?.idContact || rest?.uuid) ?? parametters.idContact;
  const id = tacheFrom === TABLE.CONTACT ? idContact : idCandidat;
  const handleServices =
    tacheFrom === TABLE.CONTACT
      ? { id, editTache: editTacheContact, addTache: addTacheContact }
      : { id, editTache: editTacheCandidat, addTache: addTacheCandidat };

  const props = { reloadingData, setReloadingData, snackbarShowMessage, ...handleServices };

  const handlePageChange = (newPage) => {
    setPage(newPage + 1);
  };

  const handleOpenDialog = (row) => {
    setTacheInfo({ affecteA: row.affecteA, tacheId: row.id, id });
    setOpenDialogDelete(true);
  };

  const handleCloseDialog = () => {
    if (loadingToDelete) return;
    setOpenDialogDelete(false);
  };

  const handleDeleteTaches = () => {
    (async () => {
      setLoadingToDelete(true);
      try {
        snackbarShowMessage("Patientez svp!", "warning", null);
        const res = await deleteTache(tacheInfo.tacheId);
        snackbarShowMessage(res.data);
        setLoadingToDelete(false);
        handleCloseDialog();
        setReloadingData(!reloadingData);
      } catch {
        snackbarShowMessage("Erreur de suppression de la donnée, veuillez réessayer plus tard.", "error", 4000);
        setLoadingToDelete(false);
      }
    })();
  };

  useEffect(() => {
    let active = true;
    (async () => {
      setLoading(true);
      setTaches([]);
      try {
        const newTaches = tachesTermines
          ? await getAllTachesFaites(page, id)
          : await getAll(page, id);
        if (!active) return;
        const data =
          tacheFrom === TABLE.CONTACT
            ? newTaches.data.TachesContact
            : newTaches.data.TachesCandidat;
        setTaches(data);
        setCount(newTaches.data.count);
      } catch {
        if (!active) return;
        snackbarShowMessage("Erreur de chargement des tâches.", "error", 4000);
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => { active = false; };
  }, [page, reloadingData, tachesTermines, id]);

  const columns = [
    {
      field: "dateTime",
      headerName: "DATE / HEURE",
      flex: 1.2,
      minWidth: 140,
      renderCell: ({ value }) => (
        <Typography variant="body2" sx={{ fontSize: '1rem', color: '#374151' }}>
          {moment(value?.date).format("DD/MM/YYYY HH:mm")}
        </Typography>
      ),
    },
    {
      field: "affectePar",
      headerName: "AFFECTÉE PAR",
      flex: 1.2,
      minWidth: 130,
      renderCell: ({ value }) => (
        <Typography variant="body2" sx={{ fontSize: '1rem', color: '#374151' }}>
          {value}
        </Typography>
      ),
    },
    {
      field: "affecteA",
      headerName: "AFFECTÉE À",
      flex: 1.2,
      minWidth: 130,
      renderCell: ({ value }) => (
        <Typography variant="body2" sx={{ fontSize: '1rem', color: '#374151' }}>
          {value}
        </Typography>
      ),
    },
    {
      field: "statut",
      headerName: "STATUT",
      flex: 0.8,
      minWidth: 100,
      renderCell: ({ value }) => (
        <Chip
          label={value ? "FAIT" : "À FAIRE"}
          size="small"
          sx={{
            fontSize: '0.7rem',
            fontWeight: 600,
            letterSpacing: '0.04em',
            backgroundColor: value ? '#d1fae5' : '#ebf4fb',
            color: value ? '#065f46' : '#02357a',
            border: `1px solid ${value ? '#6ee7b7' : '#aed6f1'}`,
            borderRadius: '6px',
            height: 22,
          }}
        />
      ),
    },
    {
      field: "commentaire",
      headerName: "COMMENTAIRE",
      flex: 2,
      minWidth: 160,
      renderCell: ({ value }) => (
        <Box sx={{ fontSize: '1rem', color: '#374151', overflow: 'hidden' }}>
          <LabelReadMoreReadLess data={value} enableCollapse={false} />
        </Box>
      ),
    },
    {
      field: "actions",
      headerName: "ACTIONS",
      width: 120,
      sortable: false,
      filterable: false,
      renderCell: ({ row }) => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}>
          <ViewTacheModal
            affecteA={row.affecteA}
            affectePar={row.affectePar}
            commentaire={row.commentaire?.replace(/<[^>]*>?/gm, '')}
            statut={row.statut}
            dateTime={row.dateTime?.date}
          />
          <FormTacheModal
            {...props}
            editMode={true}
            oldAffecteA={row.affecteAId}
            oldStatut={row.statut}
            oldCommentaire={row.commentaire}
            oldDateTime={row.dateTime?.date}
            tacheId={row.id}
          />
          <Tooltip title="Supprimer">
            <IconButton
              size="small"
              onClick={() => handleOpenDialog(row)}
              sx={{ color: '#ef4444', '&:hover': { backgroundColor: '#fef2f2' } }}
            >
              <Delete fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      ),
    },
  ];

  const dialogDeleteProps = {
    handleClose: handleCloseDialog,
    open: openDialogDelete,
    handleConfirm: handleDeleteTaches,
    loading: loadingToDelete,
    label: `Voulez vous vraiment supprimer la tâche de ${tacheInfo.affecteA}?`,
    title: "Supprimer la tâche",
  };

  return (
    <>
      <DialogDeleteCustom {...dialogDeleteProps} />
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5 }}>
        <FormTacheModal editMode={false} {...props} />
        <FormControlLabel
          control={
            <Switch
              checked={tachesTermines}
              onChange={(e) => setTachesTermines(e.target.checked)}
              size="small"
              sx={{
                '& .MuiSwitch-switchBase.Mui-checked': { color: '#03407b' },
                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#03407b' },
              }}
            />
          }
          label={
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <DoneAll sx={{ fontSize: 16, color: tachesTermines ? '#03407b' : '#9ca3af' }} />
              <Typography sx={{ fontSize: '1rem', fontWeight: 500, color: tachesTermines ? '#02357a' : '#6b7280', letterSpacing: '0.04em' }}>
                TÂCHES TERMINÉES
              </Typography>
            </Box>
          }
          sx={{ mr: 1 }}
        />
      </Box>

      <DataGrid
        rows={taches}
        columns={columns}
        getRowId={(row) => row.id}
        loading={loading}
        rowCount={count}
        paginationMode="server"
        paginationModel={{ page: page - 1, pageSize: 50 }}
        onPaginationModelChange={(model) => handlePageChange(model.page)}
        pageSizeOptions={[50]}
        disableRowSelectionOnClick
        disableColumnFilter
        disableColumnMenu
        autoHeight
        density="compact"
        sx={{
          border: '1px solid #e5e7eb',
          borderRadius: '12px',
          overflow: 'hidden',
          backgroundColor: '#fff',
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#f8fafc',
            borderBottom: '2px solid #e5e7eb',
          },
          '& .MuiDataGrid-columnHeader': {
            backgroundColor: '#f8fafc',
          },
          '& .MuiDataGrid-columnHeaderTitle': {
            fontSize: '1rem',
            fontWeight: 700,
            color: '#6b7280',
            letterSpacing: '0.07em',
            textTransform: 'uppercase',
          },
          '& .MuiDataGrid-row': {
            borderBottom: '1px solid #f3f4f6',
            '&:hover': { backgroundColor: '#fafafa' },
          },
          '& .MuiDataGrid-cell': {
            borderBottom: 'none',
            display: 'flex',
            alignItems: 'center',
            py: 0.5,
          },
          '& .MuiDataGrid-footerContainer': {
            borderTop: '1px solid #e5e7eb',
            backgroundColor: '#f8fafc',
          },
          '& .MuiDataGrid-selectedRowCount': { display: 'none' },
          '& .MuiTablePagination-root': { fontSize: '1rem' },
          '& .MuiDataGrid-overlayWrapper': { minHeight: 80 },
        }}
        localeText={{
          noRowsLabel: 'Aucune tâche trouvée.',
          MuiTablePagination: {
            labelRowsPerPage: 'Lignes par page :',
            labelDisplayedRows: ({ from, to, count }) =>
              `${from}–${to} sur ${count !== -1 ? count : `plus de ${to}`}`,
          },
        }}
      />
    </>
  );
}

export default withSnackbar(TabPanelTaches);
